/**
 *
 * DateBlocks
 *
 */
import { Component } from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";
import ArrowButton from "basicComponents/ArrowButton/ArrowButton";
import { FormattedMessage } from "react-intl";
import GlobalMessages from "messages/messages";
import Block, { WIDTH, MARGIN } from "./Block";

class DateBlocks extends Component {
  static propTypes = {
    duration: PropTypes.number,
    dates: PropTypes.array,
    onClick: PropTypes.func.isRequired,
    selectedIndex: PropTypes.number,
    colorFunction: PropTypes.func,
    plannedTreatmentId: PropTypes.number,
  };

  static defaultProps = {
    duration: 0,
    selectedIndex: -1,
  };

  state = {
    offset: 0,
  };

  handleBlockClicked = data => {
    this.props.onClick(data);
  };

  handleLeftClicked = () => {
    this.setState(prevState => {
      const newOffset = prevState.offset - 1;
      if (newOffset < 0) {
        return {};
      }
      return { offset: newOffset };
    });
  };

  handleRightClicked = () => {
    this.setState(prevState => {
      const newOffset = prevState.offset + 1;
      if (newOffset >= this.props.dates.length - 2) {
        return {};
      }
      return {
        offset: newOffset,
      };
    });
  };
  // This is used to change the offset on render to the selectedIndex.. need to fix!
  componentDidUpdate(prevProps) {
    if (prevProps.dates !== this.props.dates)
      // this is to move the block in the center when it is clicked
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ offset: this.props.selectedIndex - 1 });
  }

  render() {
    const remOffset = this.state.offset * (WIDTH + MARGIN) * -1;
    const endReached = this.state.offset >= this.props.dates.length - 3;
    const length = this.props.dates.length;
    return (
      <div>
        <Content>
          <ArrowButton
            disabled={this.state.offset === 0}
            onClick={this.handleLeftClicked}
            left
            id="arrowPrevButton"
          />
          <Scroller>
            <Wrapper length={length}>
              {length <= 0 && (
                <TextWrapper>
                  <FormattedMessage {...GlobalMessages.noPlannedTimeSlots} />
                </TextWrapper>
              )}
              {length > 0 &&
                this.props.dates.map((date, index) => (
                  <Block
                    key={`${date.id}${date.planned_date_time_from}`}
                    duration={this.props.duration}
                    onClick={this.handleBlockClicked}
                    data={date}
                    offset={remOffset}
                    colorFunction={this.props.colorFunction}
                    scale={this.props.selectedIndex === index ? 1.15 : 1}
                  />
                ))}
            </Wrapper>
          </Scroller>
          <ArrowButton
            disabled={endReached}
            onClick={this.handleRightClicked}
            id="arrowNextButton"
          />
        </Content>
      </div>
    );
  }
}

const Content = styled.div`
  display: flex;
  width: 100%;
  height: 9rem;
  justify-content: center;
`;

const Scroller = styled.div`
  height: 100%;
`;

const TextWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

const Wrapper = styled.div`
  display: flex;
  height: 100%;

  padding-top: ${({ length }) => (length > 0 ? "15px" : "0px")};

  width: ${(WIDTH + MARGIN) * 3 - MARGIN + 1}rem;
  padding-left: ${({ length }) => (length > 0 ? "0.5rem" : "0px")};
  overflow: hidden;
`;

export default DateBlocks;
